module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-backoffice-driver-list row column"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column small-4"
  }, [_c('label', [_vm._v("Status"), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.status),
      expression: "search.status"
    }],
    attrs: {
      "disabled": _vm.search.deleted
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.search, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("All")]), _c('option', [_vm._v("NEW")]), _c('option', [_vm._v("WAITING")]), _c('option', [_vm._v("ACCEPTED")]), _c('option', {
    attrs: {
      "value": "AUTO_ACCEPTED"
    }
  }, [_vm._v("AUTO ACCEPTED")]), _c('option', {
    attrs: {
      "value": "AUTO_WAITING"
    }
  }, [_vm._v("AUTO WAITING")]), _c('option', {
    attrs: {
      "value": "AUTO_WAITING_OWFF"
    }
  }, [_vm._v("AUTO WAITING OWFF")]), _c('option', {
    attrs: {
      "value": "PENDING_CONFIRMATION"
    }
  }, [_vm._v("PENDING CONFIRMATION")]), _c('option', {
    attrs: {
      "value": "PENDING_ALLOCATION"
    }
  }, [_vm._v("PENDING ALLOCATION")]), _c('option', {
    attrs: {
      "value": "VOIDED"
    }
  }, [_vm._v("VOIDED")]), _c('option', {
    attrs: {
      "value": "COMPLETED"
    }
  }, [_vm._v("COMPLETED")]), _c('option', [_vm._v("REJECTED")])])])]), _c('div', {
    staticClass: "column"
  }, [_c('label', [_vm._v("SUB STATUS"), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.sub_status),
      expression: "search.sub_status"
    }],
    attrs: {
      "disabled": _vm.search.deleted
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.search, "sub_status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("All")]), _c('option', {
    attrs: {
      "value": "BACKOFFICE_ASSIGNED"
    }
  }, [_vm._v("BACKOFFICE ASSIGNED")]), _c('option', {
    attrs: {
      "value": "AUTO_ASSIGNED"
    }
  }, [_vm._v("AUTO ASSIGNED")])])])]), _c('div', {
    staticClass: "column"
  }, [_c('label', [_vm._v("Show deleted"), _c('input-switch', {
    model: {
      value: (_vm.search.deleted),
      callback: function($$v) {
        _vm.$set(_vm.search, "deleted", $$v)
      },
      expression: "search.deleted"
    }
  })], 1)])]), _c('base-list', {
    attrs: {
      "component": _vm.component,
      "dataLoader": _vm.dataLoader,
      "search": _vm.search
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-24ea02cf!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/backoffice/DriversReservationRequestList.vue
// module id = 2347
// module chunks = 1